import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { X, MapPinned } from "lucide-react";

// Réglage Admin : département principal (défaut déduit de l'adresse) + départements fréquemment utilisés (tri des pickers, jamais de blocage).
export function DepartmentSettings({ org, onSaved }) {
  const [depts, setDepts] = useState([]);
  const [main, setMain] = useState(org?.department_code || "");
  const [prio, setPrio] = useState(org?.priority_departments || []);
  const [add, setAdd] = useState("");
  useEffect(() => { api.get("/departments").then((r) => setDepts(r.data)).catch(() => {}); }, []);
  useEffect(() => { setMain(org?.department_code || ""); setPrio(org?.priority_departments || []); }, [org]);
  const name = (c) => depts.find((d) => d.code === c)?.name || c;
  const save = async () => {
    try { await api.patch("/organization", { department_code: main || org?.department_code_effective || null, priority_departments: prio }); toast.success("Départements enregistrés"); onSaved?.(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-testid="settings-departments">
      <h2 className="font-heading font-bold text-brand-900 flex items-center gap-2"><MapPinned className="w-5 h-5 text-accent-700" />Départements</h2>
      <p className="text-sm text-slate-500 mt-1">Les établissements de ces départements sont proposés en premier dans les listes (après vos favoris). Les autres départements restent toujours accessibles par la recherche.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
        <div>
          <label className="text-sm font-semibold text-slate-700">Département principal</label>
          <select data-testid="dept-main" value={main} onChange={(e) => setMain(e.target.value)} className="mt-1 h-11 w-full rounded-lg border border-slate-200 px-3 bg-white text-sm">
            <option value="">Déduit de l'adresse ({org?.department_code_effective ? `${org.department_code_effective} — ${name(org.department_code_effective)}` : "non déterminé"})</option>
            {depts.map((d) => <option key={d.code} value={d.code}>{d.code} — {d.name}</option>)}
          </select>
        </div>
        <div>
          <label className="text-sm font-semibold text-slate-700">Départements fréquemment utilisés</label>
          <div className="flex gap-2 mt-1">
            <select data-testid="dept-add-select" value={add} onChange={(e) => setAdd(e.target.value)} className="h-11 flex-1 rounded-lg border border-slate-200 px-3 bg-white text-sm">
              <option value="">Ajouter un département…</option>
              {depts.filter((d) => !prio.includes(d.code)).map((d) => <option key={d.code} value={d.code}>{d.code} — {d.name}</option>)}
            </select>
            <Button type="button" data-testid="dept-add" variant="outline" disabled={!add} onClick={() => { setPrio([...prio, add]); setAdd(""); }} className="h-11">Ajouter</Button>
          </div>
          <div className="flex flex-wrap gap-2 mt-2">
            {prio.map((c) => <span key={c} data-testid={`dept-chip-${c}`} className="inline-flex items-center gap-1 text-xs font-bold bg-accent-50 text-accent-800 border border-accent-200 rounded-full px-2.5 py-1">{c} — {name(c)}<button type="button" onClick={() => setPrio(prio.filter((x) => x !== c))} aria-label="Retirer"><X className="w-3 h-3" /></button></span>)}
            {prio.length === 0 && <span className="text-xs text-slate-400">Aucun (le département principal est utilisé).</span>}
          </div>
        </div>
      </div>
      <Button data-testid="dept-save" onClick={save} className="bg-accent-600 hover:bg-accent-700 h-11 mt-4">Enregistrer</Button>
    </div>
  );
}
